import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="admin-login">
      <Card className="max-w-md w-full p-10 lg:p-12 border-border bg-white text-center">
        <div className="w-12 h-12 mx-auto rounded-xl bg-primary text-primary-foreground grid place-items-center">
          <Lock className="w-5 h-5" />
        </div>
        <h1 className="font-display text-3xl font-semibold tracking-tighter mt-5">Owner sign-in</h1>
        <p className="text-muted-foreground mt-2 text-sm leading-relaxed">
          The admin dashboard is restricted to the business owner. Sign in with the Google account associated with the business.
        </p>
        <Button
          data-testid="admin-google-signin"
          onClick={signIn}
          className="btn-primary rounded-full mt-7 px-6 h-11 w-full"
        >
          Sign in with Google
        </Button>
        <p className="text-xs text-muted-foreground mt-4">
          You'll be redirected to Google. Only authorized accounts can access this page.
        </p>
      </Card>
    </div>
  );
}
